import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import { LimitedFunctionalityBanner } from '../../../../../../components/LimitedFunctionalityBanner/LimitedFunctionalityBanner'
import lockedFeatureService from '../../../../../../services/LockedFeatureService'
import { LockedFeatureId } from '../../../../../../types/LockedFeature'
import { useLiveEventsTrackerAccessCheck } from '../../../../../account/hooks/roleHooks'

type NewsCardContentUpgradePlanSectionSectionProps = {
  lockedFeatureId?: LockedFeatureId
  showLimitedContent?: boolean
}

export const NewsCardContentUpgradePlanSectionSection: FC<NewsCardContentUpgradePlanSectionSectionProps> = ({ lockedFeatureId, showLimitedContent }) => {
  const { t } = useTranslation()
  const hasAccessToLiveEventsTracker = useLiveEventsTrackerAccessCheck()
  // Only the "unlock this game" wording + Contact Us link is appropriate when the user
  // already has the Live Events Tracker role but the specific game isn't unlocked for them.
  // Users without the LE role at all should see the default "upgrade your plan" banner that
  // opens the LockedFeature dialog for the LiveEventsTracker feature.
  const isGameLocked = showLimitedContent && lockedFeatureId === LockedFeatureId.LiveEventsTracker && hasAccessToLiveEventsTracker

  return (
    <Box>
      <LimitedFunctionalityBanner lockedFeatureId={lockedFeatureId as LockedFeatureId} href={isGameLocked ? lockedFeatureService.contactUrl : undefined}>
        {isGameLocked ? t('common:desc_unlock_game') : undefined}
      </LimitedFunctionalityBanner>
    </Box>
  )
}
